module.exports = __webpack_public_path__ + "img/before-2.65688417.png";